"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const React = __importStar(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const Logo_1 = require("./Logo");
const Footer = () => {
    return (React.createElement(StyledFooter, { className: "footer" },
        React.createElement("div", { className: "logo-link", onClick: () => {
                if (typeof window !== 'undefined') {
                    window.location.href = '/';
                }
            } },
            React.createElement(Logo_1.FooterLogo, { className: "logo" })),
        React.createElement(StyledFooterNavContainer, { className: "desktop" },
            React.createElement(StyledFooterNav, null,
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/verdivurdering-selge-eiendom" }, "Selge eiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kjope-bolig" }, "Kj\u00F8pe eiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/selge-fritidseiendom-hytte" }, "Fritidseiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kontorer" }, "Kontor / megler"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/nybygg" }, "Nybygg"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/styling-og-klargjoring" }, "Styling og klargj\u00F8ring"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kjope-eiendom" }, "KJ\u00D8P"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/boligbytte-selge-eiendom" }, "Boligbytte")),
            React.createElement(StyledFooterNav, null,
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kampanje/kvadrat" }, "Kvadrat"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kampanje/presisjon" }, "Digital boligannonsering"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/leveransebeskrivelse-selge-bolig" }, "V\u00E5r leveranse"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/content/selge-bolig-tips-rad" }, "Tips og r\u00E5d ved salg"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/boligsok" }, "PrivatMegleren Eiendomss\u00F8k"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/finansiering-boliglan" }, "Finansiering"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/om-oss" }, "Om oss"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/personvern" }, "Personvern"))),
        React.createElement(StyledFooterNavContainer, { className: "mobile" },
            React.createElement(StyledFooterNav, null,
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/verdivurdering-selge-eiendom" }, "Selge eiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kjope-bolig" }, "Kj\u00F8pe eiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/selge-fritidseiendom-hytte" }, "Fritidseiendom"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kontorer" }, "Kontor / megler"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/nybygg" }, "Nybygg"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/styling-og-klargjoring" }, "Styling og klargj\u00F8ring"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kjope-eiendom" }, "KJ\u00D8P"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/boligbytte-selge-eiendom" }, "Boligbytte"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kampanje/kvadrat" }, "Kvadrat"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/kampanje/presisjon" }, "Digital boligannonsering"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/leveransebeskrivelse-selge-bolig" }, "V\u00E5r leveranse"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/content/selge-bolig-tips-rad" }, "Tips og r\u00E5d ved salg"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/boligsok" }, "PM Eiendomss\u00F8k"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/finansiering-boliglan" }, "Finansiering"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/om-oss" }, "Om oss"),
                React.createElement(StyledFooterLinkAnchor, { href: "https://privatmegleren.no/personvern" }, "Personvern"))),
        React.createElement(StyledFooterNavContainer, { className: "w290" },
            React.createElement(StyledFooterNav, null,
                React.createElement(StyledFooterLinkAnchor, { className: "small-footer-link", href: "https://www.facebook.com/pmnorge/" }, "facebook")),
            React.createElement(StyledFooterNav, null,
                React.createElement(StyledFooterLinkAnchor, { className: "small-footer-link", href: "https://www.instagram.com/privatmegleren_norge/?hl=nb" }, "instagram"))),
        React.createElement(StyledFooterLinkAnchor, { className: "policy-link", as: "a", href: "https://privatmegleren.no/personvern" }, "Personvern og cookies")));
};
exports.Footer = Footer;
exports.default = exports.Footer;
const StyledFooter = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  align-items: center;
  padding: 3rem 1.5rem;
  margin-top: 3rem;
  width: 100%;
  background: #171719;
  border-top: 1px solid rgb(36, 37, 37);
  position: relative;
  z-index: 1;

  .logo {
    margin-bottom: 2.5rem;
  }

  .logo-link {
    &:hover {
      cursor: pointer;
    }
  }
`;
const StyledFooterNavContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  width: 30rem;
  margin: 0 auto;

  &.w290 {
    width: 18.125rem;
  }

  &.desktop {
    display: flex;
  }

  &.mobile {
    display: none;
  }

  @media all and (max-width: 650px) {
    width: 100%;
    flex-flow: column;

    &.desktop {
      display: none;
    }

    &.mobile {
      display: flex;
    }
  }
`;
const StyledFooterNav = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  align-items: center;
  margin-right: 1.25rem;

  @media all and (max-width: 650px) {
    margin-right: 0;
  }
`;
const StyledBaseFooterLink = (0, styled_components_1.css) `
  padding: 0 0 0.625rem 0;
  text-decoration: none;
  font-size: 1.125rem;
  font-weight: 300;
  color: white;

  &:focus {
    outline: none;
  }

  &:hover {
    color: #e7cfa7;
  }

  &.small-footer-link {
    padding: 1.25rem 0 0 0.625rem;
    font-size: 1rem;
  }

  &.policy-link {
    margin-top: 1.875rem;
    font-size: 1rem;
  }
`;
const StyledFooterLinkAnchor = styled_components_1.default.a `
  ${StyledBaseFooterLink}

  &.developed-by {
    font-size: 14px;
    color: rgb(100, 100, 100);
  }
`;
//# sourceMappingURL=Footer.js.map